import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {CustomFieldState} from "./CustomFieldState";
import {
	JOB_CUSTOM_FIELD_CREATED,
	JOB_CUSTOM_FIELD_UPDATED,
	JOB_CUSTOM_FIELDS_FETCHED,
	LEAD_CUSTOM_FIELD_CREATED,
	LEAD_CUSTOM_FIELD_UPDATED,
	LEAD_CUSTOM_FIELDS_FETCHED,
	PARTNER_BRAND_CUSTOM_FIELD_CREATED,
	PARTNER_BRAND_CUSTOM_FIELD_UPDATED,
	PARTNER_BRAND_CUSTOM_FIELDS_FETCHED
} from "../../action/customField/actionType";

const initState: CustomFieldState = {
	jobCustomFields: none,
	leadCustomFields: none,
	partnerBrandCustomFields: none
};

const reducer = handleActions({
	[JOB_CUSTOM_FIELDS_FETCHED]: (state: CustomFieldState, action: Action<any>): CustomFieldState => {
		return {...state, jobCustomFields: option(action.payload.fields)}
	},
	[LEAD_CUSTOM_FIELDS_FETCHED]: (state: CustomFieldState, action: Action<LEAD_CUSTOM_FIELDS_FETCHED>): CustomFieldState => {
		return {...state, leadCustomFields: option(action.payload.fields)}
	},
	[PARTNER_BRAND_CUSTOM_FIELDS_FETCHED]: (state: CustomFieldState,
		action: Action<PARTNER_BRAND_CUSTOM_FIELDS_FETCHED>): CustomFieldState => {
		return {...state, partnerBrandCustomFields: option(action.payload.fields)}
	},
	[JOB_CUSTOM_FIELD_CREATED]: (state: CustomFieldState, action: Action<JOB_CUSTOM_FIELD_CREATED>): CustomFieldState => {
		return {...state, jobCustomFields: option(state.jobCustomFields.getOrElse([]).concat(action.payload.field))}
	},
	[LEAD_CUSTOM_FIELD_CREATED]: (state: CustomFieldState, action: Action<LEAD_CUSTOM_FIELD_CREATED>): CustomFieldState => {
		return {...state, leadCustomFields: option(state.leadCustomFields.getOrElse([]).concat(action.payload.field))}
	},
	[PARTNER_BRAND_CUSTOM_FIELD_CREATED]: (state: CustomFieldState,
		action: Action<PARTNER_BRAND_CUSTOM_FIELD_CREATED>): CustomFieldState => {
		return {
			...state,
			partnerBrandCustomFields: option(state.partnerBrandCustomFields.getOrElse([]).concat(action.payload.field))
		}
	},
	[JOB_CUSTOM_FIELD_UPDATED]: (state: CustomFieldState, action: Action<JOB_CUSTOM_FIELD_UPDATED>): CustomFieldState => {
		const customFields = state.jobCustomFields.getOrElse([]).map(
			cf => cf.id === action.payload.field.id ? action.payload.field : cf);
		return {...state, jobCustomFields: option(customFields)}
	},
	[LEAD_CUSTOM_FIELD_UPDATED]: (state: CustomFieldState, action: Action<LEAD_CUSTOM_FIELD_UPDATED>): CustomFieldState => {
		const customFields = state.leadCustomFields.getOrElse([]).map(
			cf => cf.id === action.payload.field.id ? action.payload.field : cf);
		return {...state, leadCustomFields: option(customFields)}
	},
	[PARTNER_BRAND_CUSTOM_FIELD_UPDATED]: (state: CustomFieldState,
		action: Action<PARTNER_BRAND_CUSTOM_FIELD_UPDATED>): CustomFieldState => {
		const customFields = state.partnerBrandCustomFields.getOrElse([]).map(
			cf => cf.id === action.payload.field.id ? action.payload.field : cf);
		return {...state, partnerBrandCustomFields: option(customFields)}
	}
}, initState);

export default reducer;